import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormUtils } from '../../../../../shared/helpers/formUtils';
import { EYesNo } from '../../../../../shared/models/types.enum';

@Component({
  selector: 'parent-threat-knowledge',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './parent-threat-knowledge.component.html',
  styleUrl: './parent-threat-knowledge.component.css'
})
export class ParentThreatKnowledgeComponent implements OnInit {

  @Input() parentInterviewData: any;
  @Output() onSaveSection2 = new EventEmitter<any>();

  yesNo = EYesNo;
  parentThreatKnowledgeForm: FormGroup = new FormGroup([]);
  
  questionList = [
    {
      question: "What do you know about the threatening situation? *",
      formControlName: "knowledge_threat",
    },
    {
      question: "What are you planning to do about this situation? *",
      formControlName: "plans",
    }
  ]

  radioQuestions = [
    {
      id: 'student_talking',
      questionText: "Have you heard he/she talk about things like this before? *",
      formControlName: 'student_talking',
      infoFormControlName: 'student_talking_information'
    },
    {
      id: 'resources',
      questionText: "Does he/she have the resources to carry out this threat? *",
      formControlName: 'resources',
    },
    {
      id: 'intended_victim',
      questionText: "Are you familiar with the intended victim? *",
      formControlName: 'intended_victim',
      infoFormControlName: 'intended_victim_information'
    }
  ];

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private formUtils: FormUtils
  ) {}

  ngOnInit() {
    this.initializeForm();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['parentInterviewData'] && this.parentInterviewData) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    const group: any = {};
    
    this.radioQuestions.forEach(question => {
      const defaultValue = this.parentInterviewData && this.parentInterviewData[question.formControlName] !== undefined
                           ? this.parentInterviewData[question.formControlName]
                           : this.yesNo.No;

      group[question.formControlName] = new FormControl(
          String(defaultValue),
          Validators.required
      );
      if (question.infoFormControlName) {
        group[question.infoFormControlName] = new FormControl({ value: this.parentInterviewData?.[question.infoFormControlName] || '', disabled: this.parentInterviewData?.[question.infoFormControlName] ? false : true });
      }
    });
    this.questionList.forEach(question => {
      group[question.formControlName] = new FormControl(this.parentInterviewData?.[question.formControlName] || '', Validators.required);
    });

    this.parentThreatKnowledgeForm = new FormGroup(group);
    this.setupFormChangeHandlers();
  }

  setupFormChangeHandlers() {
    this.radioQuestions.forEach(question => {
      const control = this.parentThreatKnowledgeForm.get(question.formControlName);
      if (control) {
        control.valueChanges.subscribe(value => {
          if (question.infoFormControlName) {
            const infoControl = this.parentThreatKnowledgeForm.get(question.infoFormControlName);
            if (infoControl) {
              this.formUtils.handleConditionChange(infoControl, value === this.yesNo.Yes);
            }
          }
        });
      }
    });
  }

  saveThreatKnowledge(): void {
    if (this.parentThreatKnowledgeForm.valid) {
      this.onSaveSection2.emit(this.parentThreatKnowledgeForm.value);
    }
  }

}
